import { createFileRoute } from "@tanstack/react-router";

import { ProviderCallbackPage } from "../../features/auth/ProviderCallbackPage";
import { validateProviderAnswer } from "../../features/auth/providerAnswer";

// Outside the signed-in and signed-out layouts: the page signs the person in itself.
export const Route = createFileRoute("/auth/callback")({
  validateSearch: validateProviderAnswer,
  component: function ProviderCallback() {
    return <ProviderCallbackPage answer={Route.useSearch()} />;
  },
});
